import { StaticQuery, graphql } from "gatsby";
import React from "react";

import {
  Section,
  Image,
  Card,
  Header2,
  Underlined,
  Paragraph,
} from "@racepointenergy/gatsby-theme-sitespark/src/components/Hero";
import { getSize } from "@racepointenergy/gatsby-theme-sitespark/src/components/Theme/utils";

export const Residential = () => (
  <Section>
    <StaticQuery
      query={graphql`
        query ApplicationsResidentialHeroImageQuery {
          file(relativePath: { eq: "garage_box.png" }) {
            ...HeroImage
          }
        }
      `}
      render={({ file }) => (
        <Image
          alt=""
          css={`
            + picture > img,
            img {
              object-position: 75% 50%;
              @media screen and (min-width: ${getSize("tablet720")}) {
                object-position: 72% 50%;
              }
            }
          `}
          file={file}
        />
      )}
    />
    <Card
      css={`
        @media screen and (min-width: ${getSize(
            "default"
          )}) and (max-width: 479px) {
          padding: 33px 38px 39px 38px;
        }
        @media screen and (min-width: ${getSize(
            "mobile480"
          )}) and (max-width: 719px) {
          padding: 33px 44px 46px 46px;
        }
        @media screen and (min-width: ${getSize(
            "tablet720"
          )}) and (max-width: 959px) {
          padding-right: 40px;
          width: 406px;
        }
        @media screen and (min-width: ${getSize(
            "tablet960"
          )}) and (max-width: 1199px) {
          padding: 32px 28px 34px 50px;
          width: 415px;
        }
        @media screen and (min-width: ${getSize(
            "desktop1200"
          )}) and (max-width: 1919px) {
          padding: 44px 48px 42px 50px;
          width: 436px;
        }
        @media screen and (min-width: ${getSize("desktop1920")}) {
          width: 583px;
        }
      `}
    >
      <Header2 id="residential">
        {"Residential"}
        <Underlined
          css={`
            @media screen and (min-width: ${getSize(
                "tablet960"
              )}) and (max-width: 1199px) {
              margin-top: 19px;
            }
          `}
        />
      </Header2>
      <Paragraph
        css={`
          @media screen and (min-width: ${getSize(
              "default"
            )}) and (max-width: 767px) {
            margin-top: 19px;
          }
          @media screen and (min-width: ${getSize(
              "tablet960"
            )}) and (max-width: 1199px) {
            margin-top: 24px;
          }
          @media screen and (min-width: ${getSize(
              "desktop1200"
            )}) and (max-width: 1919px) {
            margin-top: 22px;
          }
        `}
      >
        {
          "Whether your needs include energy security, economic savings or environmental sustainability, Savant Power can provide a complete energy package. Seamlessly integrate renewable and traditional sources of power generation with an energy storage system monitored and controlled with Flexible Load Management."
        }
      </Paragraph>
    </Card>
  </Section>
);
